import moment from "moment";

export const toCamelCase = (string: any) => {
  if (string)
    return string.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  else return "";
};

export const formatRequestTypeText = (value?: string): string => {
  if (!value || value.length < 4) return "";

  const textArr = value.split("");
  textArr[0] = textArr[0].toUpperCase();
  textArr[3] = textArr[3].toUpperCase();
  textArr.splice(3, 0, "-");

  return textArr.join("");
};


export const convertEPochToDate = (epoch: string): string => {
  if (epoch) {
    // const epocdate = moment(new Date(parseInt(epoch)).toLocaleString());
    const epochInt = Number(epoch);
    let epocdate;
    if (isNaN(epochInt)) {
      epocdate = moment(epoch);
    } else {
      epocdate = moment(epochInt);
    }
    //  const today = moment();
    // if (
    //   moment(epocdate.format("DD-MMM-YY")).isSame(today.format("DD-MMM-YY"))
    // ) {
    //   return epocdate.format("hh:mm:ss A");
    // } else {
    //   return epocdate.format("DD-MMM-YY hh:mm:ss A ");
    // }
    return epocdate.format("DD-MMM-YY hh:mm:ss A");
  } else return "";
};

export const timeDifference = (targetDate: string, format: string): string => {
  // Parse the target date using moment
  const targetMoment = moment(targetDate, format);

  // Calculate the time difference in milliseconds
  const timeDiffInMilliseconds = moment().diff(targetMoment);

  // Convert milliseconds to minutes and hours
  const minutes = Math.floor(timeDiffInMilliseconds / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days !== 0) {
    return `${days} days ${hours % 24} hours ${
      minutes % (24 * 60)
    } minutes ago`;
  } else if (hours !== 0) {
    return `${hours} hours ${minutes % 60} minutes ago`;
  } else {
    return `${minutes} minutes ago`;
  }
};

export const getLatestTime = (momentTimes: moment.Moment[], format: string) => {
  const latestTime = moment.max(momentTimes);
  return latestTime.format("HH:mm:ss") === "Invalid date"
    ? ""
    : latestTime.format("HH:mm:ss");
};

export const convertEpochToDateOnly = (epoch: string): string => {
  if (epoch) {
    const epochInt = Number(epoch);
    let epocdate;
    if (isNaN(epochInt)) {
      epocdate = moment(epoch);
    } else {
      epocdate = moment(epochInt);
    }
    return epocdate.format("DD-MMM-YY");
  } else {
    return "";
  }
};
export const convertEPochToDateWithoutDash = (epoch: string): string => {
  if (epoch) {
    // const epocdate = moment(new Date(parseInt(epoch)).toLocaleString());
    const epochInt = Number(epoch);
    let epocdate;
    if (isNaN(epochInt)) {
      epocdate = moment(epoch);
    } else {
      epocdate = moment(epochInt);
    }
    //  const today = moment();
    // if (
    //   moment(epocdate.format("DD-MMM-YY")).isSame(today.format("DD-MMM-YY"))
    // ) {
    //   return epocdate.format("hh:mm:ss A");
    // } else {
    //   return epocdate.format("DD-MMM-YY hh:mm:ss A ");
    // }
    return epocdate.format("DD MMM YYYY hh:mm:ss A");
  } else return "";
};
